<template>
  <div>
    <div class="myfield">
      <div class="alert alert-danger" v-if="getFirstname === ''">
        {{ $t('firstnameRequired') }}
      </div>
      <input
        type="text"
        id="firstname"
        v-model="firstname"
        :placeholder="$t('firstname')"
        @keyup.enter="trySubmit"
      />
      <label for="firstname">{{ $t("firstname") }}</label>
    </div>
    <div class="myfield">
      <div class="alert alert-danger" v-if="getLastname === ''">
        {{ $t('lastnameRequired') }}
      </div>
      <input
        type="text"
        id="lastname"
        v-model="lastname"
        :placeholder="$t('lastname')"
        @keyup.enter="trySubmit"
      />
      <label for="lastname">{{ $t("lastname") }}</label>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      firstname: '',
      lastname: ''
    }
  },
  computed: {
    ...mapGetters({
      try: 'register/try',
      getFirstname: 'register/firstname',
      getLastname: 'register/lastname',
      errors: 'register/errors'
    })
  },
  watch: {
    try () {
      this.$router.push({
        path: '/register',
        query: { firstname: this.firstname, lastname: this.lastname }
      })
    }
  },
  mounted () {
    this.firstname = this.getFirstname
    this.lastname = this.getLastname
  },
  methods: {
    ...mapMutations({
      trySubmit: 'register/trySubmit'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "registration": "რეგისტრაცია",
    "firstname": "სახელი",
    "lastname": "გვარი",
    "id_number": "პირადი ნომერი",
    "firstnameRequired": "გთხოვთ შეიყვანოთ სახელი",
    "lastnameRequired": "გთხოვთ შეიყვანოთ გვარი"
  },
  "en": {
    "registration": "Registration",
    "firstname": "First name",
    "lastname": "Last name",
    "id_number": "ID",
    "firstnameRequired": "Please fill firstname field",
    "lastnameRequired": "Pleae fill lastname field"
  }
}
</i18n>
